import { styled as muiStyled } from '@mui/material'

export const PrintableNextVisitColumnLeftSide = muiStyled('div')(
  () => `
/* The prescription always renders at A4 width, so this column must keep a consistent
   width regardless of viewport. A viewport-based 20% (on small screens) squeezed the
   column to ~150px and forced the next-visit date onto multiple lines. */
width: 50%;
flex-shrink: 0;
`,
)
